import styled from "styled-components";

export const LoaderContainer = styled.div`
  height: 35vh;
`;
